import angular from 'angular'

class financialReportCtrl {
    constructor($scope, httpRequest, logger, sweetalert) {
        $scope.selectConfig = {
            year: [new Date().getFullYear() - 2, new Date().getFullYear() - 1, new Date().getFullYear()],
            reportType: ['年报', '季报'],
            quarter: [{ name: '一季度', code: '01' }, { name: '二季度', code: '02' }, { name: '三季度', code: '03' }, { name: '四季度', code: '04' }],
        }
        $scope.yearModel = $scope.selectConfig.year[1]
        $scope.reportTypeModel = $scope.selectConfig.reportType[0]
        const currMonth = new Date().getMonth() + 1
        const currQuarter = Math.floor((currMonth % 3 == 0 ? (currMonth / 3) : (currMonth / 3 + 1))) - 1
        $scope.quarterModel = $scope.selectConfig.quarter.filter((item) => item.code == currQuarter)[0]
        $scope.params = {
            pageNum: 1,
            pageSize: 10,
            param: {
                keyword: '',
                skssq: $scope.yearModel,
                type: 1,
            },
        }
        $scope.params.param.type = 1
        $scope.queryList = function queryList() {
            httpRequest.post_qrySbKmye($scope.params).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        $scope.queryList()
        $scope.tabClick = function tabClick(val) {
            $scope.params.param.type = val
            $scope.queryList()
        }
        $scope.selectChange = function selectChange() {
            $scope.quarterModel = this.quarterModel
            $scope.params.param.skssq = $scope.reportTypeModel == '季报' ? $scope.yearModel + $scope.quarterModel.code : $scope.yearModel
            $scope.importconfig.data.skssq = $scope.params.param.skssq
            $scope.queryList()
        }
        $scope.selectChangeType = function selectChangeType() {
            if ($scope.reportTypeModel == '季报') {
                $scope.yearModel = new Date().getFullYear()
                $scope.quarterModel = $scope.selectConfig.quarter.filter((item) => item.code == currQuarter)[0]
                $scope.params.param.skssq = $scope.yearModel + $scope.quarterModel.code
            } else {
                $scope.yearModel = new Date().getFullYear() - 1
                $scope.params.param.skssq = $scope.yearModel
            }
            $scope.importconfig.data.skssq = $scope.params.param.skssq
            $scope.queryList()
        }
        // 导入配置
        $scope.importconfig = {
            code: 'KMYE',
            downloadAppName: host.etcloudSb,
            appName: host.etcloudSb,
            validate: {
                pattern: '.xlsx,.xls,',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls,',
                },
            },
            data: {
                skssq: $scope.params.param.skssq,
            },
            url: 'dl/dlTaskService/importKmye',
            callback() {
                // 回掉，可选
                $scope.queryList()
            },
            uploadCallback() {
                $scope.upload()
            },
            uploadId: 'financial-report-upload',
        }
        $scope.upload = function upload() {
            httpRequest.get_preCondition().then((res) => {
                if (res.data.success) {
                    sweetalert.confirm('操作提醒', '导入后将全面覆盖已有的财务报表，确定要导入吗？').then(() => {
                        angular.element('#financial-report-upload').click()
                    })
                } else {
                    logger.logError('请联系管理员先设置税务会计科目及会计科目')
                }
            })
        }
        $scope.edit = function edit(obj, k) {
            httpRequest.post_modSbKmye(obj).then((res) => {
                if (res.data.success) {
                    $scope.queryList()
                    obj[k] = false
                }
            })
        }
        $scope.enterEvent = function enterEvent(e, obj, k) {
            const keycode = window.event ? e.keyCode : e.which
            if (keycode == 13) {
                httpRequest.post_modSbKmye(obj).then((res) => {
                    if (res.data.success) {
                        $scope.queryList()
                        obj[k] = false
                    }
                })
            }
        }
        $scope.submitReport = function submitReport() {
            httpRequest.get_getOrgModel({ zsxmDm: 10104 }).then((res) => {
                if (res.data.value.length > 0) {
                    function initReport() {
                        httpRequest.post_sbCwbbInit({
                            mbuuid: res.data.value[0].mbuuid,
                            sbzlDm: res.data.value[0].sbzlDm,
                            skssq: $scope.params.param.skssq,
                        }).then((data) => {
                            if (data.data.success) {
                                logger.logSuccess('申报表已生成！')
                            }
                        })
                    }
                    httpRequest.post_isSbCwbbInit({
                        mbuuid: res.data.value[0].mbuuid,
                        sbzlDm: res.data.value[0].sbzlDm,
                        skssq: $scope.params.param.skssq,
                    }).then((val) => {
                        if (val.data.value) {
                            sweetalert.confirm('操作提醒', '此操作将覆盖已有的申报表中数据，确定要生成吗？').then(() => {
                                initReport()
                            })
                        } else {
                            initReport()
                        }
                    })
                } else {
                    logger.logError('所得税申报模板未启用，请启用模板')
                }
            })
        }
    }
}

financialReportCtrl.$inject = ['$scope', 'httpRequest', 'logger', 'sweetalert']
export default financialReportCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/incomeTax/financialReport/financialReportCtrl.js